class Toast {
  constructor(level, message) {
    this.message = message;
    this.id = `toast-${Math.random().toString(16).slice(2)}`;
    this.removeId = `${this.id}-remove`;
    this.color = "bg-gray-500 dark:bg-neutral-700";

    switch (level) {
      case "success":
        this.color = "bg-teal-500";
        break;
      case "info":
        this.color = "bg-blue-500";
        break;
      case "error":
        this.color = "bg-red-500";
        break;
      case "warning":
        this.color = "bg-yellow-500";
        break;
      default:
        break;
    }
  }

  remove() {
    const toastElement = document.getElementById(this.id);
    if (toastElement) {
      toastElement.classList.add("translate-x-5", "opacity-0");
      setTimeout(() => toastElement.remove(), 300);
    }
  }

  show() {
    const toast = document.createElement("div");
    toast.className = `my-2 z-50 transition duration-300 max-w-xs text-sm text-white rounded-xl shadow-lg ${this.color}`;
    toast.setAttribute("aria-labelledby", `${this.id}-label`);
    toast.tabIndex = "-1";
    toast.id = this.id;
    toast.role = "alert";
    toast.innerHTML = `
        <div id="${this.id}-label" class="flex p-3 gap-2">
            <div>
              ${this.message}
            </div>
            <div class="ms-auto">
                <button id="${this.removeId}" type="button" class="inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100" aria-label="Close">
                <span class="sr-only">Close</span>
                <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
                </button>
            </div>
        </div>`;
    const el = document.getElementById("toast-container");
    el.appendChild(toast);

    const closeButton = document.getElementById(this.removeId);
    if (closeButton) {
      closeButton.addEventListener("click", () => this.remove());
    }
  }
}

function onToast(e) {
  const toast = new Toast(
    e.detail.level,
    decodeURIComponent(escape(e.detail.message))
  );
  toast.show();

  setTimeout(function () {
    toast.remove();
  }, 5000);
}

document.body.addEventListener("toast", onToast);
